import { render, staticRenderFns } from "./HelpList.vue?vue&type=template&id=148e3b48&scoped=true&"
import script from "./HelpList.vue?vue&type=script&lang=js&"
export * from "./HelpList.vue?vue&type=script&lang=js&"
import style0 from "./HelpList.vue?vue&type=style&index=0&id=148e3b48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148e3b48",
  null
  
)

export default component.exports